import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchLive, resetDemo } from '../../actions/liveDataActions';
import { cancelLive, cancelLiveFromWorker, unsubscribeLive } from '../../actions/matchDataActions';
import { cancelLive as resetCancelLive } from '../../actions/workerAction';
import { withRouter } from 'react-router-dom';
import { isSpectator, extract, me, isDemo, isLiveEnded, isLiveAlreadyRated } from '../../helpers';
import _ from 'lodash';
import './Live.css';
import Layouts from '../../components/layouts/Layouts';
import Headers from '../../components/content/live/headers/Headers';
import Followers from '../../components/content/live/followers/Followers';
import ListActions from '../../components/content/live/actions/list/ListAction';
import ConfirmModal from '../../components/modals/confirm/ConfirmModal';
import InformationModal from '../../components/modals/information/InformationModal';
import ServerErrorModal from '../../components/modals/error/ServerErrorModal';
import axios from 'axios';
import { API_HOST } from '../../config.env';
import execLiveWorker from '../../worker/liveWorker';
import PropTypes from 'prop-types';
import Toolbar from '../../components/headers/live/Toolbar';
import { removeBatchCustomData } from '../../services/notifications';
import RefreshButton from '../../components/content/refresh/RefreshButton';
import DeclarationActionModal from '../../components/modals/live/DeclarationActionModal';
import RatingLiveModal from '../../components/modals/rating/RatingLiveModal';
import Title from './components/Title';
import AddActionButton from './components/AddActionButton';
import SwitchNotifButton from './components/SwitchNotifButton';

class Live extends React.Component {
    constructor(props) {
        super(props);
        this.id = this.props.match.params.id
        this.state = {
            live: {},
            match: {},
            show: false,
            showDeclarationModal: false,
            receiveNotif: localStorage.getItem(`/notif/lives/${this.id}`) || 1,
            actionType: [],
            showRefreshButton: false,
            refreshButtonText: '',
            showError: false,
            showInfoDemo: true,
            isRated: localStorage.getItem(`/rate/lives/${this.id}`) || 0
        }

        this.startInterval = this.startInterval.bind(this);
        this.stopInterval = this.stopInterval.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.connexionReducer !== this.props.connexionReducer) {
            this.fetchData();
        }
    }

    fetchData() {
        const access = this.props.connexionReducer
        this.props.fetchLive(this.id, access).then(() => {
            this.setState({
                live: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`] : {},
                match: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`].match : {}
            });
            this.startInterval();
        });

        const headers = {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        };
        if(localStorage.getItem('action_types')) {
            this.setState({actionType: JSON.parse(localStorage.getItem('action_types'))})
        }
        else {
            axios.get(`${API_HOST}/api/action_types?pagination=false`, { headers }).then(response => {
                if(response.status === 200) {
                    this.setState({actionType: response.data['hydra:member']})
                    localStorage.setItem('action_types', JSON.stringify(response.data['hydra:member']));
                }
            })
        }
    }

    componentWillUnmount() {
        this.stopInterval();
    }

    startInterval() {
        if(!isDemo(this.id)) {
            const {pageReducer, connexionReducer, fetchLive, resetCancelLive, cancelLiveFromWorker} = this.props
            this.interval = setInterval(() => {
                if(pageReducer === 'upcomingMatch') {
                    execLiveWorker(connexionReducer, this.id, {
                        fetch: () => fetchLive(this.id, connexionReducer).then(() => {
                            this.setState({
                                live: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`] : {},
                                match: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`].match : {}
                            });
                        }),
                        cancel: resetCancelLive,
                        refresh: cancelLiveFromWorker,
                        setShowRefreshButton: v => this.setState({showRefreshButton: v}),
                        setRefreshButtonText: t => this.setState({refreshButtonText: t})
                    })
                }
            }, 5000);
        }
    }

    stopInterval() {
        clearInterval(this.interval)
    }

    render() {
        const {pageReducer, connexionReducer} = this.props;
        const {match, live, receiveNotif, showDeclarationModal, actionType, showRefreshButton, refreshButtonText, show, showInfoDemo, showError, isRated} = this.state
        const settings = pageReducer === 'upcomingMatch' && !isDemo(this.id) ? [{
            key: 'cancel',
            name: isSpectator([live]) ? 'Arrêter de suivre ce live' : 'Annuler mon live',
            onClick: () => {
                this.stopInterval()
                this.setState({show: true})
            }
        }] : [];

        return (
            <Layouts
                modifier='ls_live_page'
                toolbar={() => (
                    <Toolbar 
                        title={<Title match={match} />} 
                        back='/matches' 
                        settings={isLiveEnded(live) ? [] : settings}
                        isSpectator={isSpectator([live]) && !isLiveEnded(live)}
                        idLive={this.id}
                    >
                        <Headers live={live} match={match} pageReducer={pageReducer} />
                    </Toolbar>
                )}
                fab={() => !isLiveEnded(live) ? <AddActionButton live={live} match={match} pageReducer={pageReducer} onClick={() => {
                    this.stopInterval();
                    this.setState({showDeclarationModal: true})
                }} /> : ''}
                footer={() => <SwitchNotifButton live={live} receiveNotif={receiveNotif} setReceiveNotif={v => this.setState({receiveNotif: v})} id={this.id} />}
                modal={() => (
                    <DeclarationActionModal 
                        id={this.id}
                        actionType={actionType}
                        match={match}
                        live={live}
                        open={showDeclarationModal}
                        onCancel={() => {
                            this.startInterval()
                            this.setState({showDeclarationModal: false})
                        }}
                        access={connexionReducer}
                    />
                )}
            >
                <Followers live={live} />
                {
                    isSpectator([live]) && pageReducer === 'upcomingMatch' &&
                    <RefreshButton 
                        inProp={showRefreshButton} 
                        text={refreshButtonText}
                        onClick={() => {
                            this.props.fetchLive(this.id, connexionReducer).then(() => {
                                this.setState({
                                    live: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`] : {},
                                    match: this.props.liveDataReducer[`/api/lives/${this.id}`] ? this.props.liveDataReducer[`/api/lives/${this.id}`].match : {}
                                });
                            });
                            this.startInterval();
                            this.setState({showRefreshButton: false})
                        }}
                        stopInterval={this.stopInterval}
                    />
                }
                <ListActions 
                    pageReducer={pageReducer} 
                    live={live}
                    startInterval={this.startInterval}
                    stopInterval={this.stopInterval}
                />
                <ConfirmModal 
                    show={show}
                    content={isSpectator([live]) ? 
                        'En arrêtant le suivi de ton live, tu ne recevras plus de notifications et ne sera plus informé des faits de match. \nEs-tu sûr de vouloir arrêter le suivi de ce live ?' 
                        : 'Es-tu sûre de vouloir annuler ton statut de Live Scorer?'}
                    onCancel={() => {
                        this.startInterval();
                        this.setState({show: false})
                    }}
                    title='Attention'
                    onOk={()=> {
                        this.setState(prevState => {
                            return {...prevState, show: !prevState.show}
                        })
                        if(isSpectator([live])) {
                            this.unsubscribe(live.id || extract(live['@id'], '/', 3));
                        }
                        else {
                            this.cancel(live.id || extract(live['@id'], '/', 3), match.maNo)
                        }
                    }}
                />
                <InformationModal
                    show={this.props.workerReducer[`/api/lives/${this.id}`] === 'canceled'}
                    content={`${live && live.author ? live.author.nickname : ''} a annulé son live`}
                    onCancel={()=> {
                        this.props.resetCancelLive(`/api/lives/${this.id}`, '');
                        this.props.history.push('/matches');
                    }}
                />
                {
                    isDemo(this.id) && _.toNumber(sessionStorage.getItem('isDemoVisited')) !== 1 &&
                    <InformationModal
                        show={showInfoDemo}
                        title='Voici un exemple de live'
                        content={'vous pouvez modifier, supprimer editer les actions et en ajouter pour vous familiariser avec l\'outil'}
                        onCancel={() => this.setState({showInfoDemo: false})}
                    />
                }
                <ServerErrorModal show={showError} onCancel={() => this.setState(prevState => ({...prevState, showError: !prevState.showError}))} />
                {
                    isSpectator([live]) && pageReducer === 'upcomingMatch' &&
                    <RatingLiveModal 
                        visible={isLiveEnded(live) && !isLiveAlreadyRated(live) && _.toNumber(isRated) === 0} 
                        onClose={() => {this.setState({isRated: 1}); localStorage.setItem(`/rate/lives/${this.id}`, 1)}} live={live}
                        access={connexionReducer}
                    />
                }
            </Layouts>
        )
    }

    headers() {
        return {
            headers: {
                Accept: 'application/ld+json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.props.connexionReducer}`
            }
        }
    }

    unsubscribe(id) {
        axios.post(`${API_HOST}/api/users/${me().id}/unsubscribe`, {unsubscribe: [`/api/lives/${id}`]}, this.headers()).then(response => {
            //remove tag batch
            removeBatchCustomData([`live_${id}`]);
            this.props.unsubscribeLive(id, response.data['@id']);
            this.props.history.push('/matches');
        }).catch(() => this.setState({showError: true}));
    }

    cancel(live,match) {
        axios.delete(`${API_HOST}/api/lives/${live}`, this.headers()).then(() => {
            this.props.cancelLive(live, match);
            this.props.history.push('/matches')
        }).catch(() => this.setState({showError: true}))
    }

}

const mapStateToProps = ({liveDataReducer, pageReducer, workerReducer, connexionReducer}) => ({liveDataReducer, pageReducer, workerReducer, connexionReducer});

const mapDispatchToProps = dispatch => bindActionCreators({fetchLive, cancelLive, resetCancelLive, cancelLiveFromWorker, unsubscribeLive, resetDemo}, dispatch);

Live.propTypes = {
    match: PropTypes.object.isRequired,
    fetchLive: PropTypes.func.isRequired,
    resetCancelLive: PropTypes.func.isRequired,
    cancelLiveFromWorker: PropTypes.func.isRequired,
    liveDataReducer: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    pageReducer: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    workerReducer: PropTypes.array
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Live));